import styled from 'styled-components/macro'
import { theme } from 'styled-tools'

const bg = '#fff'
const shadow = theme('shadows.high')

const Menu = styled.nav`
  background: ${bg};
  box-shadow: ${shadow};

  &:focus {
    outline: 0;
  }
`

export default Menu
